module.exports = __webpack_public_path__ + "img/info.ba4fdc62.svg";